export default "__VITE_PUBLIC_ASSET__25843cf1__"